import {createApp} from 'vue';
const axios = require('axios');
import dateFormat, { masks } from "dateformat";


const inquiries = {
    __id        : 'vueInquiries',
    _element    : null,
    app         : null,
    init() {
        const el = document.getElementById('vueInquiries');

        if (el) {
            createApp({
                delimiters: ['@{', '}'],
                data() {
                    return {
                        inquiryHash : null,
                        inquiry : null,
                        message : ''
                    }
                },
                methods :
                {
                    loadInquiry(inquiryHash)
                    {
                        this.inquiryHash = inquiryHash;
                        if (this.inquiryHash) {
                            const route = '/actions/mm/inquiry/show';
                            const queryString = '?hash='+this.inquiryHash;
                            const url = route+queryString;

                            axios.get(url)
                            .then(this.loadInquiry__callback)
                            .catch(function (error) {});
                        }
                    },

                    loadInquiry__callback(response)
                    {
                        if (typeof response === 'object' && typeof response.data.item === 'object') {
                            this.inquiry = response.data.item;
                        }
                    },

                    sendAnswer()
                    {
                        const route = '/actions/mm/inquiry/answer';
                        const queryString = '?hash='+this.inquiryHash;
                        const url = route+queryString;

                        const queryArgs = { message : this.message };

                        axios({
                            method: 'post',
                            url: url,
                            data: queryArgs
                        })
                        .then(this.sendAnswer__callback)
                        .catch(function (error) {
                            // handle error
                            console.log(error);
                        });
                    },

                    sendAnswer__callback(response)
                    {
                        if (typeof response === 'object' && response.data.status === 'ok') {
                            console.log('reload inquiry');
                            this.loadInquiry(this.inquiryHash);
                            this.message = '';
                        }
                    },

                    formatDate(date)
                    {
                        return dateFormat(date, "dd.mm.yyyy', kl.' HH:MM");
                    }
                },
                created()
                {}
            }).mount('#vueInquiries');
        }

    },
    reload() {
        return this.init();
    }
};

export { inquiries };